import { render, staticRenderFns } from "./emptyTable.vue?vue&type=template&id=7904c91c"
import script from "./emptyTable.vue?vue&type=script&lang=js"
export * from "./emptyTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports